import toast from "react-hot-toast";
import { customDateFormatType } from "../../utils/utils";
import { formatDateHourDb } from "../../utils/tools";

const { clientAPI } = require("../client");

export const getStatusText = (status) => {
  switch (status) {
    case "APPROVED":
      return "Đã được duyệt";
    case "REJECTED":
      return "Không được phê duyệt";
    default:
      return "Đang chờ phê duyệt";
  }
};

export const registerCheckInCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/registerCheckIn", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/registerCheckIn/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI("delete", `/registerCheckIn/${id}`);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getId: async (id) => {
    try {
      const response = await clientAPI("get", `/registerCheckIn/${id}`);
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approve: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/registerCheckIn/approve/${id}`,
        data
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  // Hoàn tác đơn Không được phê duyệt về Chưa duyệt để duyệt lại
  revert: async (id) => {
    try {
      const response = await clientAPI("put", `/registerCheckIn/revert/${id}`);
      return response;
    } catch (error) {
      console.error("Revert error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  export: async (entries, param) => {
    try {
      const options = {
        limit: entries,
        page: 1,
      };

      if (param.search !== undefined) options.search = param.search;
      if (param.employeeId) options.employeeId = param.employeeId;
      if (param.status) options.status = param.status;
      if (param.saleBlockId) options.saleBlockId = param.saleBlockId;
      if (param.saleAreaId) options.saleAreaId = param.saleAreaId;
      if (param.branchId) options.branchId = param.branchId;
      if (param.startDate)
        options.startTime = customDateFormatType(param.startDate);
      if (param.endDate) options.endTime = customDateFormatType(param.endDate);

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI(
        "get",
        `/registerCheckIn?${queryParams}`
      );
      const dataExport = response?.items.map((item) => {
        return {
          status: getStatusText(item?.status) || "",
          employeeCode: item?.employeeObject?.code || "",
          employeeFullname: item?.employeeObject?.fullName || "",
          saleBlockName: item?.saleBlock?.name || "",
          saleAreaName: item?.saleArea?.name || "",
          branchName: item?.branch?.name || "",
          checkinPlace: item?.branch?.name || "",
          workingDayRate: item?.branch?.name || "",
          comment: item?.branch?.name || "",
          checkinTime: item?.checkinTime
            ? formatDateHourDb(item?.checkinTime)
            : "",
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
